import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import store from '../../../store/configureStore';
import SideSearchBox from '../../../components/SideSearchBox';
import SideCategoryBox from './SideCategoryBox';
import BlogListMain from './BlogListMain';
import { changeActiveItemAction } from '../../../actions/navAction';
import { changeTopBannerAction } from '../../../actions/topBannerAction';
import { Businesses, PagesForCaption, CaptionCodes } from '../../../config/Helper';
import BlogListSideBlocks from './BlogListSideBlocks';
import captionApi from '../../../api/captionApi';

import $ from "jquery/dist/jquery.js";
import ScrollToTop from '../../home/ScrollToTop/ScrollToTop';
import { setBlogBusinessAction } from '../../../actions/blogAction';

class BlogList extends Component {

    constructor(props) {
        super(props);
        const categoryStore = Businesses.indexOf(store.getState().blog.business);
        this.state = {
            search_key: '',
            category: categoryStore,
            subCate: 0,
            sectionTitle: {},
            curPage: 1,
            perpage: 6,
            isCategory: false
        }
        // this.perpage = 6
        this.getSectionTitles = this.getSectionTitles.bind(this);
        this.onSearchKeyChanged = this.onSearchKeyChanged.bind(this);
        this.onCategoryChanged = this.onCategoryChanged.bind(this);
        this.onPerPageChange = this.onPerPageChange.bind(this);
        // this.setCurPage = this.setCurPage.bind(this);
        // store.dispatch(setBlogBusinessAction(this.props.match.params.business === undefined ? -1 : parseInt(this.props.match.params.business, 10)))
    }

    componentWillMount() {

        store.dispatch(changeActiveItemAction(Businesses.indexOf('blog')));
        store.dispatch(changeTopBannerAction({
            page: 'blog',
            showSearch: false,
            isHome: false
        }));
        this.perpage = $('#perpage_blog_selector').val()
    }

    componentDidMount() {
        window.onSetClass('light');
        window.onClose();
        window.scrollTop('#');
        this.getSectionTitles();
        // queryParams = { [queryParams[0]] : queryParams[1]}
        this.perpage = $('#perpage_blog_selector').val()
    }

    componentDidUpdate() {
        window.onClose();
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        this.getSectionTitles();
        this.perpage = $('#perpage_blog_selector').val()
    }



    getSectionTitles() {
        captionApi.getCaptions('blogs').then((json) => {
            if (json.status === 200) {
                this.setState({
                    sectionTitle: json.data
                });
            } else {

            }
        })
    }

    onSearchKeyChanged(key) {
        if (this.state.search_key === key) {
            return;
        }

        this.setState({
            search_key: key
        });
    }

    onCategoryChanged(business, sub) {

        if (this.state.category === business && this.state.subCate === sub) {
            return;
        }
        store.dispatch(setBlogBusinessAction(business))
        this.setState({
            category: business,
            subCate: sub,
            isCategory: true
        });
    }
    onPerPageChange() {
        this.setState({
            perpage: $('#perpage_blog_selector').val(),
        });

    }
    render() {
        return (
            <div>

                <div style={{ width: "130px", marginLeft: "133px", marginTop: "30px" }}>
                    <select className="form-control rounded" name="" id="perpage_blog_selector" onChange={this.onPerPageChange}>
                        <option value={6} key={1}>6</option>
                        <option value={10} key={2}>10</option>
                        <option value={14} key={3}>14</option>
                    </select>
                </div>
                <section className="ftco-section blog-list" id="blog_main_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 pr-lg-4">
                                <BlogListMain
                                    search_key={this.state.search_key}
                                    category={this.state.category}
                                    subCate={this.state.subCate}
                                    curPage={this.state.curPage}
                                    setPerpage={this.state.perpage}
                                    isCategory={this.state.isCategory}
                                // setCurPage = {this.setCurPage}
                                />
                            </div>
                            <div className="col-lg-4 p-4 recent-place">
                                <div className="row">
                                    <div className="col-md-11 ml-auto">

                                        <SideSearchBox onSearch={(key) => this.onSearchKeyChanged(key)} />

                                        <SideCategoryBox
                                            title={this.state.sectionTitle[CaptionCodes[PagesForCaption.indexOf('blogs')].indexOf('blog_category')] === undefined ?
                                                "" : this.state.sectionTitle[CaptionCodes[PagesForCaption.indexOf('blogs')].indexOf('blog_category')].title}
                                            onCategory={(business, sub) => { this.onCategoryChanged(business, sub) }}
                                            activeBusiness={this.state.category} />

                                        <BlogListSideBlocks
                                            title={this.state.sectionTitle[CaptionCodes[PagesForCaption.indexOf('blogs')].indexOf('blog_other_blogs')] === undefined ?
                                                "" : this.state.sectionTitle[CaptionCodes[PagesForCaption.indexOf('blogs')].indexOf('blog_other_blogs')].title}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <ScrollToTop />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
    };
}

export default withRouter(connect(mapStateToProps)(BlogList));